import React from 'react';
import { NavigationProviderProps } from './types';

export const NavigationContext = React.createContext<NavigationProviderProps | undefined>(undefined);
NavigationContext.displayName = 'NavigationContext';
